import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import PostItem from "../../components/Post/PostItem"
import { SimpleGrid, Heading, Box } from "@chakra-ui/react"
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import Transition from "../../components/Layout/Transition";
import a from '../../images/background/27.svg'
import Background from "../../components/Layout/Background";


export default function Experience() {
    const data = useStaticQuery(
        graphql`
        query {
            allContentfulExperience {
              totalCount
              edges {
                node {
                    title
                    workDescription {
                        raw
                    }
                    company
                    date
                    featuredImage {
                        fluid {
                            src
                        }
                    }
                }
              }
            }
          } 
        `
    )

    return (
        <section>
            <Box position="relative" alignItems="stretch">
                <Background src={a} left="-22vw" top="20vw" width='12vw' />
                <Heading as="h1" size="2xl" mb={12}>💻 Experience</Heading>
                <SimpleGrid
                    rows={[1, 1, Math.ceil(data.allContentfulExperience.totalCount / 2)]}
                    columns={[1, 1, 2]}
                    gap={12}
                >
                {data.allContentfulExperience.edges.map((edge, i) => {
                    return (
                        <Transition>
                                <PostItem
                                    key={i}
                                    title={edge.node.title} 
                                    description={documentToReactComponents(JSON.parse(edge.node.workDescription.raw))} 
                                    image={edge.node.featuredImage.fluid.src} 
                                    company={edge.node.company}
                                    date={edge.node.date}
                                    isExperience
                                />
                        </Transition>
                    )
                })}
            </SimpleGrid>
            </Box>
        </section>
    )
}